<!--LOADING-->
<ng-template [ngIf]="isLoading">
  <app-loading-page class="white-top-theme"></app-loading-page>
</ng-template>
<!--END LOADING-->
<!--SUBSCRIPTION DETAIL-->
<ng-template [ngIf]="!isLoading">
  <section>
    <!--SUBSCRIPTION HEADER HERO-->
    <!--NOTE: Don't show Request a Quote for BeyondCX and Agent Platform-->
    <ng-container
      *ngIf="selectedSubscription && selectedSubscriptionUIConfiguration; else unavailable">
      <app-hero-banner
        [id]="selectedSubscription.slugName"
        [name]="'Subscription'"
        [title]="selectedSubscription.name"
        heroImageCss="{{ '-hero' }}"
        [displayCss]="['flexbox', 'justify-space-between', 'gap-3-rem']"
        [alignContentCss]="['hero-wrapper-left', 'text-color-white']"
        [gradientOverlayCss]="'gradient-overlay'"
        [routeType]="
          name === subscriptionType.AGENT_PLATFORM_SUBSCRIPTION ||
          name === subscriptionType.BEYOND_CX_SUBSCRIPTION
            ? 'external'
            : 'modal'
        "
        (sendClick)="
          showContactSales
            ? scrollIntoView('contact-sales')
            : selectedSubscriptionUIConfiguration.showModal
            ? openModal($event)
            : '';
          sendGoogleAnalytics('Subscription Detail', 'click', actionLabel)
        "
        [description]="selectedSubscription.description"
        [customButtonCss]="['btn-primary', 'larger-btn', 'padding-right-small']"
        [customDescriptionCss]="'sub-description'"
        [showButton]="
          name === subscriptionType.PURECONNECT_SUBSCRIPTION
            ? ''
            : name === subscriptionType.AI_ESSENTIAL_SUBSCRIPTION
            ? false
            : showHeroButton
        "
        [route]="environment.docebo.agent_platform_login_url"
        [actionLabel]="selectedSubscriptionUIConfiguration.actionLabel">
        <!--NOTE: content is being binded by 'subHeader' in hero banner-->
        <div content class="flexbox justify-content-center align-items-center">
          <img
            class="beyond-subscription"
            src="/assets/img/{{ selectedSubscription.icon + '-hero' }}.png"
            width="90%" />
        </div>
      </app-hero-banner>
    </ng-container>
    <!--END SUBSCRIPTION HEADER HERO-->

    <!--SHOW ANNOUNCEMENTS-->
    <ng-container
      *ngIf="
        selectedSubscriptionUIConfiguration?.showAnnouncements &&
        selectedSubscription?.slugName !== subscriptionType.POINTILLIST_SUBSCRIPTION
      ">
      <ng-container *ngTemplateOutlet="announcements"></ng-container>
    </ng-container>
    <!--END SHOW ANNOUNCEMENTS-->

    <!--POINTILLIST CMS CONTENT-->
    <ng-container
      *ngIf="
        selectedSubscriptionUIConfiguration?.showCMSContent &&
        selectedSubscription?.slugName === subscriptionType.POINTILLIST_SUBSCRIPTION
      ">
      <app-pointillist-detail [name]="selectedSubscription?.slugName"></app-pointillist-detail>
    </ng-container>
    <!--END POINTILLIST CMS CONTENT-->

    <!--RECOMMENDED FOUNDATION-->
    <!--NOTE: Only show for Genesys Engage on-premises, Genesys Cloud, and PureConnect Learning Subscriptions (Docebo subscriptions)
    anything else like BeyondCX and Agent Platform will not show this-->
    <ng-container *ngIf="selectedSubscriptionUIConfiguration?.showRecommendedFoundationalCourses">
      <ng-container *ngIf="selectedSubscription">
        <app-recommended-foundational-courses
          [actionButtonCss]="actionButtonCss"
          [selectedSubscription]="selectedSubscription?.shortcutName"
          [title]="'Begin with a Solid Foundation'"
          description="{{
            'Here are some recommended foundational courses to become a ' +
              selectedSubscription.shortcutName +
              ' Professional.'
          }}"
          [queryParams]="getSearchQuery()"
          [courseIds]="selectedSubscriptionUIConfiguration.courseIds"
          (sendClick)="sendGoogleAnalytics('Subscription Detail', 'click', 'View All Courses')"
          [selectedSubscriptionSlug]="[selectedSubscription?.slugName]">
        </app-recommended-foundational-courses>
      </ng-container>
    </ng-container>
    <!--END RECOMMENDED FOUNDATION-->

    <!--SHOW ANNOUNCEMENTS-->
    <ng-container
      *ngIf="
        selectedSubscriptionUIConfiguration?.showAnnouncements &&
        selectedSubscription?.slugName === subscriptionType.POINTILLIST_SUBSCRIPTION
      ">
      <ng-container *ngTemplateOutlet="announcements"></ng-container>
    </ng-container>
    <!--END SHOW ANNOUNCEMENTS-->

    <!--CMS STATIC CONTENT-->
    <!--TODO: Make this more generic and get rid of beyond-cx-detail section if possible.
    Currently it shows custom testimonials and form layout.-->
    <!--BEYONDCX CMS CONTENT-->
    <ng-container
      *ngIf="
        selectedSubscriptionUIConfiguration?.showCMSContent &&
        selectedSubscription?.slugName === subscriptionType.AI_ESSENTIAL_SUBSCRIPTION
      ">
      <app-beyond-cx-detail [name]="selectedSubscription?.slugName"></app-beyond-cx-detail>
    </ng-container>
    <!--END BEYONDCX CMS CONTENT-->
    <!--AGENT PLATFORM CMS CONTENT-->
    <ng-container
      *ngIf="
        (selectedSubscriptionUIConfiguration?.showCMSContent &&
          selectedSubscription?.slugName === 'agent-platform-ap-training-for-genesys-cloud-cx') ||
        selectedSubscription?.slugName === subscriptionType.AGENT_PLATFORM_SUBSCRIPTION
      ">
      <app-agent-platform-detail [name]="selectedSubscription?.slugName">
      </app-agent-platform-detail>
    </ng-container>
    <!--END AGENT PLATFORM CMS CONTENT-->

    <!--NOTE: Only show for Genesys Engage on-premises, Genesys Cloud, and PureConnect Learning Subscriptions (Docebo subscriptions)
    anything else like BeyondCX and Agent Platform will not show this-->
    <ng-container *ngIf="selectedSubscriptionUIConfiguration?.showTrainingForAllCXRoles">
      <app-hero-banner
        id="training-for-all-cx-roles-{{ selectedSubscription?.slugName }}"
        [title]="'Training for All Roles'"
        [heroImageCss]="'training-for-all-cx-roles-hero'"
        [displayCss]="'flexbox flexwrap'"
        [alignContentCss]="['hero-wrapper-left', 'text-color-black']"
        [route]="'search'"
        [queryParams]="getSearchQuery()"
        [customButtonCss]="['btn-primary', 'larger-btn', 'padding-right-small']"
        description="No matter the CX career path, find training to guide you on your continuous learning journey.<br><br>
        Browse all courses included in the {{ selectedSubscription?.name }}."
        (sendClick)="
          sendGoogleAnalytics('Subscription Detail', 'click', cardTypeCallToActions.EXPLORE_CATALOG)
        "
        [actionLabel]="cardTypeCallToActions.EXPLORE_CATALOG">
        <!--NOTE: Inject custom content-->
        <!--NOTE: content is being binded by 'content' in hero banner-->
        <div class="flexbox margin-top-large align-checkmark-items" content>
          <ul class="checkmark-list text-color-black margin-right-large">
            <li
              class="list-item"
              *ngFor="
                let trainingForAllCXRoles of selectedSubscriptionUIConfiguration.trainingForAllCXRoles
                  | slice : 0 : 4
              ">
              <span class="roles-checkmark icon small lightblue"></span>{{ trainingForAllCXRoles }}
            </li>
          </ul>
          <ul class="checkmark-list text-color-black">
            <li
              class="list-item"
              *ngFor="
                let trainingForAllCXRoles of selectedSubscriptionUIConfiguration.trainingForAllCXRoles
                  | slice : 4 : 8
              ">
              <span class="roles-checkmark icon small lightblue"></span>{{ trainingForAllCXRoles }}
            </li>
          </ul>
        </div>
      </app-hero-banner>
    </ng-container>
    <!--END TRAINING FOR ALL CX-ROLES-->

    <!--FLEXIBLE METHODS OF LEARNING-->
    <!--NOTE: Only show for Genesys Genesys Engage on-premises, Genesys Cloud, and PureConnect Learning Subscriptions (Docebo subscriptions)
    anything else like BeyondCX and Agent Platform will not show this-->
    <ng-container *ngIf="selectedSubscriptionUIConfiguration?.showFlexibleMethodsOfLearning">
      <app-flexible-learning-list [subscriptionName]="name"></app-flexible-learning-list>
    </ng-container>
    <!--END FLEXIBLE METHODS OF LEARNING-->

    <!--CERTIFICATIONS HERO-->
    <!--NOTE: buttonCss is the brand blue color and the route is the resources certification page-->
    <!--NOTE: Only show for Genesys Engage on-premises, Genesys Cloud, PureConnect, and Agent Platform LearningSubscriptions (Docebo subscriptions)
    anything else like BeyondCX and will not show this-->
    <ng-container *ngIf="selectedSubscriptionUIConfiguration?.showCertifications">
      <app-hero-banner
        id="genesys-certifications-{{ selectedSubscription?.slugName }}"
        [title]="'Genesys Certifications'"
        [heroImageCss]="'certifications-hero'"
        [customButtonCss]="['btn-brand', 'larger-btn', 'padding-right-small']"
        [alignContentCss]="['hero-wrapper-left', 'text-color-white']"
        [routeType]="
          name === subscriptionType.AGENT_PLATFORM_SUBSCRIPTION
            ? routeTypes.EXTERNAL
            : routeTypes.INTERNAL
        "
        [route]="selectedSubscriptionUIConfiguration?.certificationRoute"
        (sendClick)="
          sendGoogleAnalytics('Subscription Detail', 'click', cardTypeCallToActions.LEARN_MORE)
        "
        [description]="selectedSubscriptionUIConfiguration?.certificationDescription"
        [actionLabel]="cardTypeCallToActions.LEARN_MORE">
      </app-hero-banner>
    </ng-container>
    <!--END CERTIFICATIONS HERO-->

    <!--LEARN PATHS HERO-->
    <ng-container *ngIf="selectedSubscriptionUIConfiguration?.showLearningPaths">
      <app-hero-banner
        id="learning-paths-roles-{{ selectedSubscription?.slugName }}"
        title="Explore Learning Paths"
        [heroImageCss]="'beyond-learning-paths-hero'"
        [displayCss]="'flexbox flexwrap'"
        [alignContentCss]="['hero-wrapper-left', 'text-color-black']"
        [route]="'learning-path/home'"
        [customButtonCss]="['btn-primary', 'larger-btn', 'padding-right-small']"
        (sendClick)="
          sendGoogleAnalytics('Subscription Detail', 'click', cardTypeCallToActions.LEARN_MORE)
        "
        [description]="
          'Genesys Education has developed a variety of learning content and educational courses that meet the needs of individuals and organizations based on the work environments available to them and the modalities they learn best in, including eLearning and self-study.'
        "
        [actionLabel]="cardTypeCallToActions.LEARN_MORE">
        <!--NOTE: Inject custom content-->
        <!--NOTE: content is being binded by 'content' in hero banner-->
        <div class="flexbox margin-top-large align-checkmark-items" content>
          <ul class="checkmark-list text-color-black margin-right-large">
            <ng-container *ngIf="selectedSubscription?.product === productShortName.GENESYS_CLOUD">
              <li class="list-item">
                <span class="roles-checkmark icon small lightblue"></span>System Administrator
              </li>
              <li class="list-item">
                <span class="roles-checkmark icon small lightblue"></span>Agent
              </li>
              <li class="list-item">
                <span class="roles-checkmark icon small lightblue"></span>Business User
              </li>
              <li class="list-item">
                <span class="roles-checkmark icon small lightblue"></span>Developer
              </li>
              <li class="list-item">
                <span class="roles-checkmark icon small lightblue"></span>AI Essentials
              </li>
            </ng-container>
            <ng-container *ngIf="selectedSubscription?.product === productShortName.POINTILLIST">
              <li class="list-item">
                <span class="roles-checkmark icon small lightblue"></span>Analyst
              </li>
              <li class="list-item">
                <span class="roles-checkmark icon small lightblue"></span>Administrator
              </li>
            </ng-container>
          </ul>
        </div>
      </app-hero-banner>
    </ng-container>
    <!--END LEARN PATHS HERO-->

    <!--SUBSCRIPTION TESTIMONIALS-->
    <ng-container *ngIf="selectedSubscriptionUIConfiguration?.showTestimonials">
      <app-testimonials
        [testimonials]="selectedSubscriptionTestimonial"
        [testimonialAlignmentCSS]="['testimonial-content', 'text-align-left', 'margin-right-large']"
        [testimonialWrapperCSS]="'testimonial-wrapper-center'"
        [testimonialBackgroundCSS]="'testimonials'">
      </app-testimonials>
    </ng-container>
    <!--END SUBSCRIPTION TESTIMONIALS-->

    <!--NOTE: Only show for Genesys Engage on-premises, Genesys Cloud, and PureConnect Learning Subscriptions (Docebo subscriptions)
    anything else like BeyondCX and Agent Platform will not show this-->
    <ng-container *ngIf="selectedSubscriptionUIConfiguration?.showContactUs">
      <!--CONTACT US HERO NEW -->
      <app-contact-sales
        id="contact-sales"
        *ngIf="showContactSales && contactSalesForm"
        id="contact-us-{{ selectedSubscription?.slugName }}"
        [heroImageCss]="['contact-us-hero', 'wrapper', 'margin-top-larger', 'margin-bottom-larger']"
        [displayCss]="['columns']"
        [alignContentCss]="['text-color-white', 'margin-right-large']"
        [showButton]="false"
        [formType]="''">
      </app-contact-sales>

      <!--CONTACT US HERO OLD -->
      <app-contact-sales
        id="contact-sales"
        *ngIf="showContactSales && !contactSalesForm"
        id="contact-us-{{ selectedSubscription?.slugName }}"
        [title]="
          'Turn good customer experiences into great ones with training from Genesys experts.'
        "
        [description]="'Speak to a Genesys Education representative to learn more.'"
        [heroImageCss]="[
          'contact-us-hero-old',
          'wrapper',
          'margin-top-larger',
          'margin-bottom-larger'
        ]"
        [displayCss]="['columns']"
        [alignContentCss]="['text-color-white', 'margin-right-large']"
        [showButton]="false"
        [formType]="''">
      </app-contact-sales>
      <!--<ng-template #oldContactSection>
        <app-hero-banner
          *ngIf="!showContactSales"
          id="contact-us-{{ selectedSubscription?.slugName }}"
          [title]="
            'Turn good customer experiences into great ones with training from Genesys experts.'
          "
          [heroImageCss]="'contact-us-hero'"
          [alignContentCss]="['hero-wrapper-center', 'text-color-white']"
          [routeType]="'modal'"
          (sendClick)="
            openModal($event);
            sendGoogleAnalytics('Subscription Detail', 'click', cardTypeCallToActions.CONTACT_US)
          "
          [description]="'Speak to a Genesys Education representative to learn more.'"
          [actionLabel]="cardTypeCallToActions.CONTACT_US">
        </app-hero-banner>
      </ng-template>-->
      <!--END CONTACT US HERO-->
    </ng-container>
  </section>
</ng-template>
<!--END SUBSCRIPTION DETAIL-->

<!--REQUEST A QUOTE FORM-->
<app-modal-dialog [containerID]="'requestQuote'" [modalMaxWidth]="'modal-max-width-medium'">
  <div #modalContainer>
    <!--NOTE: Form Type 'beyondcart' is defined by Genesys Marketing. Do not change, unless Marketing request this.-->
    <app-eloqua-form [formType]="'beyondcart'" (sendClick)="closeModal($event)"></app-eloqua-form>
  </div>
</app-modal-dialog>
<!--END REQUEST A QUOTE FORM-->

<!--REQUEST A QUOTE MODAL SUCCESS MESSAGE-->
<app-modal-dialog
  [containerID]="'eloqSuccessQuoteModal'"
  [modalMaxWidth]="'modal-max-width-small'"
  (sendClick)="resetForm($event)">
  <div #modalContainer>
    <h4 class="text-align-center margin-bottom-large">Thank you for your interest!</h4>
    <p class="text-align-center">
      One of our educational advisors will contact you soon with further details.
    </p>
  </div>
</app-modal-dialog>
<!--END REQUEST A QUOTE MODAL SUCCESS MESSAGE-->

<ng-template #announcements>
  <ng-container *ngIf="selectedSubscriptionUIConfiguration?.showAnnouncements">
    <app-hero-banner
      id="announcement-{{ selectedSubscription?.slugName }}"
      [heroImageCss]="'announcement-hero'"
      [alignContentCss]="['hero-wrapper-auto', 'text-color-black']"
      [title]="announcementContent?.title"
      [showButton]="false"
      [showTitle]="announcementContent?.acf?.show_title">
      <!--NOTE: Inject custom content-->
      <!--NOTE: content is being binded by 'subHeader' in hero banner-->
      <div subHeader>
        <div class="htmlresponse" [innerHTML]="announcementContent?.content"></div>
        <ng-container
          *ngIf="selectedSubscription?.slugName !== subscriptionType.GENESYS_ENGAGE_SUBSCRIPTION">
          <app-information-banner
            [id]="selectedSubscription?.slugName"
            [customClass]="selectedSubscriptionUIConfiguration.customClass"
            [icon]="announcementContent?.acf?.icon_class"
            [bodyText]="announcementContent?.acf?.short_description | safe : 'html'"
            [actionLabel]="cardTypeCallToActions.LEARN_MORE"
            [route]="announcementContent?.acf?.route_url"
            [routeType]="routeTypes.EXTERNAL"
            [showButton]="selectedSubscriptionUIConfiguration?.showAnnouncementsButton"
            [display]="announcementContent?.acf?.display_notification">
          </app-information-banner
        ></ng-container>
      </div>
    </app-hero-banner>
  </ng-container>
</ng-template>
<ng-template #unavailable>
  <section>
    <p class="wrapper">
      Sorry for the inconvience. We are not able to load content at this time due to technical
      difficulties. You should still be available to enroll and search for courses
    </p>
  </section>
</ng-template>
